import SignInSignUpContainer from "./SignInSignUpContainer.view";

export default SignInSignUpContainer;
